const KEY = 'chitbid_landing_pending_guest';

export function setPendingGuestAction(action) {
  if (!action?.type) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(action));
  } catch {
    /* ignore */
  }
}

export function getPendingGuestAction() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearPendingGuestAction() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
